/**
 * Clone proof carousel cells for seamless CSS loop animation
 */
(function () {
    document.querySelectorAll('.carousel-track').forEach(function (track) {
      if (track.dataset.resubCloned === 'true') return;
      Array.from(track.children).forEach(function (cell) {
        var clone = cell.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        var img = clone.querySelector('img');
        if (img) img.alt = '';
        track.appendChild(clone);
      });
      track.dataset.resubCloned = 'true';
    });
  })();